module.exports = __webpack_public_path__ + "static/media/bg-bedroom.6ab49c7e.jpg";